// Shared result queue has no imports, avoiding a cycle between game/play and the worker API.
export const manualGames = new Map<number, any>();
export const prepareManualResult = (sim: any, payload: any, gid: number, day: number | undefined) => {
 const teams = sim.team.map((wrapper: any, i: number) => {
  const t = wrapper.t;
  for (const p of t.player) {
   const stats = payload.stats[i][p.id];
   const appearance=payload.appearances?.[i]?.[p.id];
   const order=appearance?.order??payload.teams[i].lineup.indexOf(p.id);
   p.battingOrder=order>=0?order:undefined;
   const position=appearance?.position??Object.entries(payload.teams[i].defense).find(([,id])=>id===p.id)?.[0];
   if(position)p.lineupPos=position;
   p.subIndex=appearance?.subIndex??(payload.pitcherUsed[i].includes(p.id)?payload.pitcherUsed[i].indexOf(p.id):0);
   if(!appearance&&!stats?.gp){delete p.battingOrder;delete p.lineupPos;delete p.subIndex;}
   // Retain native starter/position metadata. Replace only accumulated game stats.
   if (stats) for (const [key, value] of Object.entries(stats)) {
    if (Object.hasOwn(p.stat,key) && (typeof value === 'number' || Array.isArray(value))) p.stat[key] = value;
   }
   delete p.age; delete p.valueNoPot; delete p.compositeRating; delete p.ptModifier; delete p.pFatigue;
  }
  for (const key of Object.keys(t.stat)) {
   if (key === 'ptsQtrs') t.stat[key] = payload.innings[i];
   else if (key === 'pts') t.stat[key] = payload.score[i];
   else if (Array.isArray(t.stat[key])) {
    t.stat[key] = Array.from({length:10}, (_,pos) => t.player.reduce((n:any,p:any)=>n+(p.stat[key]?.[pos]??0),0));
   } else t.stat[key] = t.player.reduce((n: number,p: any) => n+(typeof p.stat[key]==='number' ? p.stat[key] : 0),0);
  }
  delete t.compositeRating; delete t.pace;
  return t;
 });
 return {gid,day,team:teams,overtimes:Math.max(0,payload.inning-9),clutchPlays:[],scoringSummary:[],neutralSite:false};
};

